import gsap from "gsap";

/** Shared duration for section headline text + rule (slider, image-tile, etc.) */
export const SECTION_HEADLINE_DURATION = 1.05;

/**
 * Appends headline tweens: text slide-up + fade; optional rule (width + opacity).
 * Requires `.page-section__headline-text` inside `headlineEl`.
 * @param {object} [options]
 * @param {boolean} [options.withRule=true] — underline animation (slider / standalone page-section__headline)
 * @param {number} [options.textY=16] — initial offset px (larger = starts lower)
 */
export function appendSectionHeadlineReveal(
  timeline,
  headlineEl,
  position = 0,
  options = {},
) {
  if (!headlineEl) {
    return false;
  }

  const { withRule = true, textY = 16 } = options;

  const headlineText = headlineEl.querySelector(".page-section__headline-text");
  if (!headlineText) {
    return false;
  }

  timeline.fromTo(
    headlineText,
    { autoAlpha: 0, y: textY },
    {
      autoAlpha: 1,
      y: 0,
      duration: SECTION_HEADLINE_DURATION,
      ease: "power2.out",
      force3D: true,
    },
    position,
  );

  if (withRule) {
    const resting =
      getComputedStyle(headlineEl)
        .getPropertyValue("--headline-rule-resting-width")
        .trim() || "50px";

    timeline.fromTo(
      headlineEl,
      {
        "--headline-rule-width": "0px",
        "--headline-rule-opacity": 0,
      },
      {
        "--headline-rule-width": resting,
        "--headline-rule-opacity": 1,
        duration: SECTION_HEADLINE_DURATION,
        ease: "power2.out",
      },
      position,
    );
  }

  return true;
}
